export const VOID_ORDER_START = 'VOID_ORDER_START';
export const VOID_ORDER_SUCCESS = 'VOID_ORDER_SUCCESS';
export const VOID_ORDER_FAILURE = 'VOID_ORDER_FAILURE';